<template>
  <v-flex
    id="quo-creation"
    md12>
    <div>
      <v-btn
        v-show="!showStepper"
        color="general"
        class="mb-2"
        dark
        @click="initQuot"
      >New Quotation
      </v-btn>
      <v-stepper
        v-show="showStepper"
        v-model="e1">
        <v-stepper-header>
          <v-stepper-step
            :complete="e1 > 1"
            :rules="[checkStep1Complete]"
            editable
            step="1"
            @click.native="goStep1">Quotation Header
            <small v-show="!step1Complete">Input required!</small>
          </v-stepper-step>

          <v-divider/>

          <v-stepper-step
            :complete="e1 > 2"
            :rules="[checkStep2Complete]"
            :editable="step1Complete"
            step="2"
            @click.native="goStep2">Items Selection
            <small v-show="!step2Complete">Input required!</small>
          </v-stepper-step>

          <v-divider/>

          <v-stepper-step
            :complete="e1 > 3"
            :editable="step2Complete"
            step="3"
            @click.native="goStep3">Items Revision
          </v-stepper-step>
          <v-divider/>
          <v-stepper-step
            :complete="e1 > 4"
            :editable="allPrevStepComplete"
            step="4"
            @click.native="goStep4">Confirmation
          </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-form
              id="form-cr"
              ref="form"
              v-model="valid1"
              :lazy-validation="lazy1"
            >
              <v-card>
                <v-card-text>
                  <v-layout
                    justify-space-between
                    wrap>
                    <v-flex
                      xs6
                      sm6
                      md3>
                      <v-text-field
                        v-model="record.status"
                        disabled
                        label="Status"
                      />
                    </v-flex>
                    <v-flex
                      xs6
                      sm6
                      md3>
                      <v-menu
                        v-model="menuDatePicker"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            :rules="[rules.required]"
                            :value="record.quotationDate"
                            label="Quotation Date (YYYY-MM-DD)"
                            required
                            prepend-icon="event"
                            v-on="on"
                          />
                        </template>
                        <v-date-picker
                          v-model="record.quotationDate"
                          no-title
                          @input="menuDatePicker = false"/>
                      </v-menu>
                    </v-flex>
                    <v-flex
                      xs12
                      sm6
                      md3>
                      <v-text-field
                        v-model="record.name"
                        :rules="[rules.required]"
                        label="Quotation Title *"
                        required
                        placeholder="Input Title..."
                        class="green-input"
                      />
                    </v-flex>
                    <v-flex
                      xs6
                      sm6
                      md3>
                      <v-text-field
                        v-model="record.termDays"
                        :rules="[rules.required,rules.number]"
                        required
                        label="Term (Days) *"
                      />
                    </v-flex>
                    <v-flex
                      xs6
                      sm6
                      md3>
                      <v-select
                        v-model="record.paymentTerm"
                        :items="paymentTerms"
                        :rules="[rules.required]"
                        menu-props="auto"
                        item-text="desc"
                        item-value="id"
                        placeholder="Select..."
                        required
                        label="Payment Term"
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      sm6
                      md3>
                      <v-autocomplete
                        v-model="record.customer.company.id"
                        :items="companies"
                        :rules="[rules.required]"
                        :search-input.sync="searchCompany"
                        hide-no-data
                        placeholder="type 3 words to search..."
                        label="Company *"
                        item-text="name"
                        item-value="id"
                        required
                        @input="getCustomers"
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      sm6
                      md3>
                      <v-select
                        v-show="showCustomerSelect"
                        :items="customers"
                        v-model="record.customerSelect"
                        :rules="[rules.required]"
                        menu-props="auto"
                        item-text="name"
                        item-value="id"
                        label="Customer *"
                        return-object
                        placeholder="Select Customer..."
                        @input="getShodans"
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      sm6
                      md3>
                      <v-select
                        v-show="showShodanSelect"
                        :items="shodans"
                        v-model="record.shodan"
                        menu-props="auto"
                        item-text="name"
                        item-value="id"
                        label="Shodan"
                        return-object
                        placeholder="Select..."
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      sm6
                      md3>
                      <v-select
                        :items="userLogins"
                        v-model="record.salesUsername"
                        :rules="[rules.required]"
                        :item-text="(item) => {return item.username + ' (' + item.employee.firstName + ')'}"
                        menu-props="auto"
                        item-value="username"
                        label="Sales Username"
                        placeholder="Select..."
                      />
                    </v-flex>
                    <!--                    <v-flex-->
                    <!--                      xs6-->
                    <!--                      sm6-->
                    <!--                      md3>-->
                    <!--                      <v-text-field-->
                    <!--                        v-model="record.discount"-->
                    <!--                        :rules="[rules.number]"-->
                    <!--                        label="Discount (%)"-->
                    <!--                      />-->
                    <!--                    </v-flex>-->
                    <v-flex
                      xs12
                      sm6
                      md3>
                      <v-textarea
                        v-model="record.footerNote"
                        label="Footer Note"
                        counter
                        clearable
                        class="green-input"
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      sm6
                      md3>
                      <v-textarea
                        v-model="record.note"
                        label="Internal Note"
                        counter
                        clearable
                        class="green-input"
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      sm6
                      md3>
                      <v-radio-group
                        v-model="record.isItemBundling"
                        :disabled="editMode"
                        label="Item Select">
                        <v-radio
                          :value="true"
                          label="Bundling"/>
                        <v-radio
                          :value="false"
                          label="Standard"/>
                      </v-radio-group>
                    </v-flex>
                    <v-flex
                      xs12
                      sm6
                      md3>
                      <v-radio-group
                        v-model="record.isVat"
                        label="VAT 11%">
                        <v-radio
                          :value="true"
                          label="Yes"/>
                        <v-radio
                          :value="false"
                          label="No"/>
                      </v-radio-group>
                    </v-flex>

                  </v-layout>
                </v-card-text>
                <v-card-actions>
                  <v-spacer/>
                  <v-btn
                    color="red darken-1"
                    flat
                    @click.stop="cancelCreation">Cancel
                  </v-btn>
                  <v-btn
                    :disabled="!valid1"
                    flat
                    color="green darken-1"
                    @click="goStep2"
                  >
                    Continue
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-form>

          </v-stepper-content>

          <v-stepper-content step="2">
            <v-flex
              xs12
              sm12
              md12>
              <item-bundling-select
                v-if="record.isItemBundling"
                ref="itemBundlingSelectComponent"/>
              <item-select
                v-if="!record.isItemBundling"
                ref="itemSelectComponent"/>
            </v-flex>
            <v-card-actions>
              <v-chip
                class="ma-2"
                color="warning"
                outlined
              >
                <v-icon left>mdi-information-outline</v-icon>
                All Prices Automatic Convert to IDR
              </v-chip>
              <v-spacer/>
              <v-btn
                color="red darken-1"
                flat
                @click.stop="e1=1">Back
              </v-btn>
              <v-btn
                :disabled="!step2Complete"
                flat
                color="green darken-1"
                @click="goStep3"
              >
                Continue
              </v-btn>
            </v-card-actions>

          </v-stepper-content>

          <v-stepper-content step="3">
            <v-data-table
              ref="itemListSortable"
              :headers="headers"
              :items="dataList"
              :expand="expand"
              dense
              hide-actions
              class="elevation-1"
            >

              <template v-slot:items="props">
                <!--                <tr @click.stop=" (props.expanded = !props.expanded)" >-->
                <!-- NOTE:  You'll need a unique ID, that is specific to the given item, for the key.   Not providing a unique key that's bound to the item object will break drag and drop sorting.  The itemKey method will return a uid for a given object using WeakMap. \
                 You could just use a property in the object with a unique value, like "props.item.name" in this case, but often getting a unique value from the object's properties can be difficult, like when adding new rows, or when the unique field is open to editing, etc. -->
                <tr
                  :key="itemKey(props.item)"
                  class="sortableRow">
                  <td
                    class="px-1"
                    style="width: 0.1%">
                    <v-btn
                      style="cursor: move"
                      icon
                      class="sortHandle">
                      <v-icon>drag_indicator</v-icon>
                    </v-btn>
                  </td>
                  <td>{{ props.item.brand }}</td>
                  <td>{{ props.item.category }}</td>
                  <td>{{ props.item.materialNo }}</td>
                  <td>
                    <v-edit-dialog
                      :return-value="props.item.qty"
                      lazy
                      large
                      @update:returnValue="onUpdateEditInline(props.item.qty, $event)"
                      @click.native.stop
                      @save="saveInline"
                      @cancel="cancelInline"
                      @close="closeInline"
                    >
                      <div class="price-format">{{ props.item.qty }}
                        <v-icon small>mdi-pencil</v-icon>
                      </div>
                      <template v-slot:input>
                        <v-text-field
                          v-model.number="props.item.qty"
                          :rules="[rules.required,rules.number]"
                          type="number"
                          placeholder="quantity"
                          single-line
                          autofocus
                        />
                      </template>
                    </v-edit-dialog>
                  </td>
                  <td>
                    <v-edit-dialog
                      :return-value.sync="props.item.stockType"
                      lazy
                      large
                      @click.native.stop
                      @save="saveInline"
                      @cancel="cancelInline"
                      @close="closeInline"
                    >
                      <div>{{ props.item.stockType }}
                        <v-icon small>mdi-pencil</v-icon>
                      </div>
                      <template v-slot:input>
                        <v-select
                          v-model="props.item.stockType"
                          :items="stockType"
                          label="Stock Type"
                          single-line
                          return-object
                          autofocus
                        />
                      </template>
                    </v-edit-dialog>
                  </td>
                  <td>{{ props.item.currency }}</td>
                  <td>
                    <v-edit-dialog
                      :return-value.sync="props.item.price.sellingPrice"
                      lazy
                      large
                      @update:returnValue="onUpdateEditInline(props.item.price.sellingPrice, $event)"
                      @click.native.stop
                      @save="saveInline"
                      @cancel="cancelInline"
                      @close="closeInline"
                    >
                      <div class="price-format">{{ toPriceFormat(props.item.price.sellingPrice) }}
                        <v-icon small>mdi-pencil</v-icon>
                      </div>
                      <template v-slot:input>
                        <v-text-field
                          v-model.number="props.item.price.sellingPrice"
                          :rules="[rules.required,rules.number]"
                          type="number"
                          placeholder="price"
                          single-line
                          counter
                          autofocus
                        />
                      </template>
                    </v-edit-dialog>
                  </td>
                  <td>{{ toPriceFormat(props.item.price.bottomPrice) }}</td>
                  <td
                    class="px-1"
                    style="width: 0.1%">
                    <view-price-line-ref
                      key="viewPriceOnce"
                      :quo-id="record.id"
                      :material-no="props.item.materialNo"
                      :company-id="record.customer.company.id"/>
                  </td>
                </tr>
              </template>
              <template
                v-slot:expand="props"
                v-if="dataList[0] && dataList[0].items && dataList[0].items.length > 0">
                <v-flex
                  :key="itemKey(props.item) + '_expand'"
                  mx-3>
                  <v-card>
                    <v-card-text align="left"><span class="expand-item">Material Desc:</span> {{ props.item.materialDesc
                    }}
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-spacer/>
                <v-flex mx-3>
                  <v-data-table
                    v-if="props.item.items && props.item.items.length > 0"
                    id="quocreation-expand-step3"
                    :items="props.item.items"
                    :headers="subHeadersBundlingExpand"

                    class="elevation-1"
                    hide-actions
                  >
                    <template v-slot:items="propsa">
                      <tr>
                        <td><v-icon
                          medium
                          class="mr-2"
                          @click.stop="removeFromDisplayItems(propsa, props )">delete
                        </v-icon>{{ propsa.item.brand }}</td>
                        <td class="">{{ propsa.item.category }}</td>
                        <td class="">{{ propsa.item.materialNo }}</td>
                        <td class="">{{ propsa.item.materialDesc }}</td>
                        <td>{{ propsa.item.qty }}</td>
                        <td class="price-format">{{ toPriceFormat(propsa.item.price.sellingPrice) }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </template>
            </v-data-table>
            <v-card-actions>
              <v-spacer/>
              <v-btn
                color="red darken-1"
                flat
                @click.stop="e1 = 2">Back
              </v-btn>
              <v-btn
                :disabled="!step2Complete"
                flat
                color="green darken-1"
                @click="goStep4"
              >
                Continue
              </v-btn>
            </v-card-actions>

          </v-stepper-content>

          <v-stepper-content step="4">
            <v-form
              id="form-final"
              ref="form-final"
            >
              <v-card>
                <v-card-text>
                  <v-layout
                    justify-space-between
                    wrap>
                    <v-flex
                      xs12
                      sm6
                      md3>
                      <v-text-field
                        v-model="record.status"
                        label="Status"
                        disabled
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      sm6
                      md3>
                      <v-text-field
                        v-model="record.quotationDate"
                        label="Quotation Date (Today)"
                        prepend-icon="event"
                        disabled
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      sm6
                      md3>
                      <v-text-field
                        v-model="record.termDays"
                        disabled
                        label="Term (Days)"
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      sm6
                      md3>
                      <v-select
                        v-model="record.paymentTerm"
                        :items="paymentTerms"
                        :rules="[rules.required]"
                        disabled
                        menu-props="auto"
                        item-text="desc"
                        item-value="id"
                        placeholder="Select..."
                        required
                        label="Payment Term"
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      sm6
                      md3>
                      <v-select
                        :items="companies"
                        v-model="record.customer.company.id"
                        disabled
                        menu-props="auto"
                        item-text="name"
                        item-value="id"
                        label="Company"
                        placeholder="Select..."
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      sm6
                      md3>
                      <v-select
                        :items="customers"
                        v-model="record.customerSelect"
                        readonly
                        menu-props="auto"
                        item-text="name"
                        item-value="id"
                        label="Customer"
                        return-object
                        placeholder="Select Company First"
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      sm6
                      md3>
                      <v-select
                        :items="shodans"
                        v-model="record.shodan"
                        readonly
                        menu-props="auto"
                        item-text="name"
                        item-value="id"
                        label="Shodan"
                        return-object
                        placeholder="Select..."
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      sm6
                      md3>
                      <v-textarea
                        v-model="record.name"
                        label="Quotation Title"
                        disabled
                        class="green-input"
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      sm6
                      md3>
                      <v-textarea
                        v-model="record.footerNote"
                        label="Footer Note"
                        disabled
                        counter

                        class="green-input"
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      sm6
                      md3>
                      <v-textarea
                        v-model="record.note"
                        label="Internal Note"

                        disabled
                        counter

                        class="green-input"
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      sm6
                      md3>
                      <v-radio-group
                        v-model="record.isVat"
                        disabled
                        label="VAT 11%">
                        <v-radio
                          :value="true"
                          label="Yes"/>
                        <v-radio
                          :value="false"
                          label="No"/>
                      </v-radio-group>
                    </v-flex>
                    <v-flex
                      xs12
                      sm6
                      md3>
                      <v-radio-group v-model="record.discType" label="Discount Type">
                        <v-radio
                          label="Percentage"
                          value="PERCENTAGE"/>
                        <v-radio
                          label="Lump Sum"
                          value="LUMP_SUM"/>
                      </v-radio-group>
                      <v-text-field
                        v-model="record.discount"
                        :rules="[rules.number]"
                        :label="discountLabel"
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      sm6
                      md3>
                      <v-text-field
                        :value="discountApplied"
                        readonly
                        outline
                        label="Discount Applied (IDR)"
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      sm6
                      md3>
                      <v-text-field
                        :value="finalQuotationPriceFormatted"
                        readonly
                        outline
                        label="Final Quotation Price Before VAT (IDR)"
                      />
                    </v-flex>

                  </v-layout>

                </v-card-text>
              </v-card>
            </v-form>
            <v-data-table
              :loading="loading"
              :headers="headersFinal"
              :items="dataList"
              :rows-per-page-items="rowsAmount"
              :total-items="totalRows"
              :expand="expand"
              item-key="id"
              dense
              hide-actions
              loading-text="Loading... Please wait"
              class="elevation-1"
            >

              <template v-slot:items="props">
                <tr
                  @click.stop=" (props.expanded = !props.expanded)">
                  <td>{{ props.item.brand }}</td>
                  <td>{{ props.item.category }}</td>
                  <td>{{ props.item.materialNo }}</td>
                  <td class="price-format">
                    {{ toPriceFormat(props.item.qty) }}
                  </td>
                  <td>
                    {{ props.item.stockType }}
                  </td>
                  <td>{{ props.item.currency }}</td>
                  <td class="price-format">
                    {{ toPriceFormat(props.item.price.sellingPrice) }}
                  </td>
                  <td class="price-format">{{ toPriceFormat(props.item.price.bottomPrice) }}</td>
                </tr>
              </template>
              <template v-slot:footer>
                <td
                  class="font-weight-bold"
                  align="right"
                  colspan="3">
                  Total
                </td>
                <td class="font-weight-bold">
                  {{ record.totalQty }}
                </td>
                <td
                  class="font-weight-bold"
                  align="right"
                  colspan="2">
                  Total
                </td>
                <td class="font-weight-bold">
                  {{ totalPriceFormatted }}
                </td>
              </template>
              <template v-slot:expand="props">
                <v-flex mx-3>
                  <v-card>
                    <v-card-text align="left"><span class="expand-item">Material Desc:</span> {{ props.item.materialDesc
                    }}
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-spacer/>
                <v-flex mx-3>
                  <v-data-table
                    v-if="props.item.items && props.item.items.length > 0"
                    id="quocreation-expand-step4"
                    :items="props.item.items"
                    :headers="subHeadersBundlingExpand"
                    class="elevation-1"
                    hide-actions
                  >
                    <template v-slot:items="props">
                      <tr>
                        <td>{{ props.item.brand }}</td>
                        <td class="">{{ props.item.category }}</td>
                        <td class="">{{ props.item.materialNo }}</td>
                        <td class="">{{ props.item.materialDesc }}</td>
                        <td>{{ props.item.qty }}</td>
                        <td class="price-format">{{ toPriceFormat(props.item.price.sellingPrice) }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </template>
            </v-data-table>
            <v-card-actions>
              <v-spacer/>
              <v-btn
                color="red darken-1"
                flat
                @click.stop="e1 = 3">Back
              </v-btn>
              <v-btn
                :disabled="!allPrevStepComplete"
                flat
                color="green darken-1"
                @click.once="finishCreation"
              >
                Finish
              </v-btn>
            </v-card-actions>

          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>

      <v-snackbar
        v-model="snack"
        :timeout="5000"
        :color="snackColor">
        {{ snackText }}
        <v-btn
          flat
          @click="snack = false">Close
        </v-btn>
      </v-snackbar>
    </div>
  </v-flex>

</template>

<script>
  import ItemSelect from './ItemSelect'
  import ItemBundlingSelect from './ItemBundlingSelect'
  import displayFormatterMixins from '../../../mixins/displayFormatterMixins'
  import Sortable from 'sortablejs'
  import ViewPriceLineRef from './ViewPriceLineRef'
  import _ from 'lodash'

  export default {
    name: 'QuoCreation',
    components: { ViewPriceLineRef, ItemBundlingSelect, ItemSelect },
    mixins: [displayFormatterMixins],
    data: () => {
      return {
        itemKeys: new WeakMap(),
        currentItemKey: 0,
        e1: 0,
        fromStep4: false,
        showStepper: false,
        editMode: false,
        menuDatePicker: false,
        valid1: false,
        lazy1: false,
        valid2: false,
        lazy2: false,
        rules: {
          required: value => !!value || 'Required.',
          max50chars: value => !value || value.length <= 50 || 'Max 50 characters',
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return !value || pattern.test(value) || 'Invalid e-mail.'
          },
          number: value => !isNaN(value) || 'Must be numeric'
        },
        showCustomerSelect: false,
        showShodanSelect: false,
        shodans: [],
        companies: [],
        customers: [],
        paymentTerms: [],
        userLogins: [],
        stockType: ['READY', 'INDENT'],
        // discRadioGroup: 'pctg',
        record: {
          id: null,
          quotationDate: '',
          paymentTerm: '',
          termDays: 30,
          name: '',
          note: '',
          footerNote: '',
          status: '',
          discount: 0,
          discType: '',
          salesUsername: '',
          itemDetails: [],
          shodan: {
            id: null,
            name: ''
          },
          totalQty: '',
          totalPrice: '',
          totalPriceAfterDisc: '',
          customer: {
            id: null,
            name: '',
            company: {
              id: null,
              name: ''
            }
          },
          isItemBundling: false,
          isVat: true,
          customerSelect: {
            id: ''
          }
        },
        defaultRecord: {
          id: null,
          quotationDate: '',
          paymentTerm: '',
          termDays: 30,
          name: '',
          note: '',
          // Info rekening sekarang tercetak di footer template quotation
          // (setiap halaman), jadi tidak lagi diisi di sini supaya tidak dobel.
          footerNote: '',
          status: 'OPEN',
          discount: 0,
          discType: 'PERCENTAGE',
          // TODO: fix it to get from Vuex. Vuex 'user' data still bugging.
          salesUsername: localStorage.getItem('username'),
          itemDetails: [],
          shodan: {
            id: null,
            name: ''
          },
          totalQty: '',
          totalPrice: '',
          totalPriceAfterDisc: '',
          customer: {
            id: null,
            name: '',
            company: {
              id: null,
              name: ''
            }
          },
          isItemBundling: false,
          isVat: true,
          customerSelect: ''
        },
        snack: false,
        snackColor: '',
        snackText: '',
        dataList: [],
        expand: true,
        loading: true,
        totalRows: 0,
        rowsAmount: [5, 10],
        headers: [
          { sortable: false },
          { text: 'Brand', value: 'brand', sortable: false },
          { text: 'Category', value: 'category', sortable: false },
          { text: 'Material', value: 'materialNo', sortable: false },
          { text: 'Qty', value: 'qty', sortable: false },
          { text: 'Stock', value: 'stockType', sortable: false },
          { text: 'Curr', value: 'curr', sortable: false },
          { text: 'Selling Price', value: 'price.sellingPrice', sortable: false },
          { text: 'Bottom Price', value: 'price.bottomPrice', sortable: false },
          { sortable: false }
        ],
        headersFinal: [
          { text: 'Brand', value: 'brand', sortable: false },
          { text: 'Category', value: 'category', sortable: false },
          { text: 'Material', value: 'materialNo', sortable: false },
          { text: 'Qty', value: 'qty', sortable: false },
          { text: 'Stock', value: 'stockType', sortable: false },
          { text: 'Curr', value: 'curr', sortable: false },
          { text: 'Selling Price', value: 'price.sellingPrice', sortable: false, align: 'end' },
          { text: 'Bottom Price', value: 'price.bottomPrice', sortable: false, align: 'end' }
        ],
        subHeadersBundlingExpand: [
          { text: 'Brand', value: 'brand', sortable: false },
          { text: 'Category', value: 'category', sortable: false },
          { text: 'Material', value: 'materialNo', sortable: false },
          { text: 'Material Desc', value: 'materialDesc', sortable: false },
          { text: 'Qty', value: 'qty', sortable: false },
          { text: 'Selling Price', value: 'price.sellingPrice', sortable: false }
        ],
        searchCompany: ''
      }
    },
    computed: {
      step1Complete () {
         return this.valid1
      },
      step2Complete () {
        return this.$store.getters['quo/selectedItems'].length > 0
      },
      allPrevStepComplete () {
        return this.valid1 && this.$store.getters['quo/selectedItems'].length > 0
      },
      computedDateFormatted () {
        return this.formatDate(this.record.quotationDate)
      },
      totalPriceFormatted () {
        return this.toPriceFormat(this.record.totalPrice)
      },
      discountLabel () {
        if (this.record.discType === 'PERCENTAGE') {
          return 'Discount (%)'
        } else {
          return 'Discount (IDR)'
        }
      },
      finalQuotationPriceFormatted () {
        if (this.record.discType === 'PERCENTAGE') { // if (this.discRadioGroup === 'PERCENTAGE') {
          return this.toPriceFormat(Math.round(this.record.totalPrice * (1 - this.record.discount / 100)))
        } else {
          return this.toPriceFormat(Math.round(this.record.totalPrice - this.record.discount))
        }
      },
      discountApplied () {
        if (this.record.discType === 'PERCENTAGE') { // if (this.discRadioGroup === 'PERCENTAGE') {
          return this.toPriceFormat(Math.round(this.record.totalPrice * (this.record.discount / 100)))
        } else {
          return this.toPriceFormat(this.record.discount)
        }
      }
    },
    watch: {
      searchCompany () {
        if (this.searchCompany && this.searchCompany.length >= 3) {
          this.debouncedGetCompanies()
        }
      }
    },
    mounted () {
      new Sortable(
        this.$refs.itemListSortable.$el.getElementsByTagName('tbody')[0],
        {
          draggable: '.sortableRow',
          handle: '.sortHandle',
          direction: 'vertical',
          onEnd: this.dragReorder
        }
      )
    },
    created () {
      // this.getCompanies()
      this.debouncedGetCompanies = _.debounce(this.getCompaniesPaging, 500)
      this.getPaymentTerms()
      this.getUserLogins()
    },
    methods: {
      dragReorder ({ oldIndex, newIndex }) {
        const movedItem = this.dataList.splice(oldIndex, 1)[0]
        this.dataList.splice(newIndex, 0, movedItem)
      },
      itemKey (item) {
        if (!this.itemKeys.has(item)) this.itemKeys.set(item, ++this.currentItemKey)
        return this.itemKeys.get(item)
      },
      onUpdateEditInline (itemVal, value) {
        itemVal = value === '' ? 0 : value
      },
      removeFromDisplayItems (rec, parentrec) {
        console.debug(rec)
        console.debug(parentrec)
        console.debug(`id child=${rec.item.id} ,id parent=${parentrec.item.id}`)
        console.debug(this.dataList)
        let parentIdx = _.findIndex(this.dataList, ['id', parentrec.item.id])
        console.debug(_.findIndex(this.dataList[parentIdx].items, ['id', rec.item.id]))
        this.dataList[parentIdx].items.splice(this.dataList[parentIdx].items.indexOf(rec.item), 1)
      },
      formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      async setTotalPriceAttribute () {
        await _.forEach(this.dataList, e => {
          e.subTotalPrice = parseInt(e.price.sellingPrice * e.qty) // IDR not allow commas
        })
        console.debug(this.dataList)
        this.record.totalPrice = await _.sumBy(this.dataList, e => {
          return parseInt(e.price.sellingPrice * e.qty) // IDR not allow commas
        })
        this.record.totalQty = await _.sumBy(this.dataList, e => parseInt(e.qty))
        // this.record.totalPriceAfterDisc = Math.round(this.record.totalPrice * (1 - this.record.discount / 100))
      },
      clearForm () {
        setTimeout(() => {
          // this.editedIndex = -1
          this.$store.commit('quo/setSelectedItems', [])
          // UTC timezone offset problem, cannot differentiated to plus or substract
          console.debug(new Date().toISOString().slice(0, 10))
          if (this.record.isItemBundling) { // Sync with the SELECT CHECKBOX
            this.$refs.itemBundlingSelectComponent.closed()
          } else {
            this.$refs.itemSelectComponent.closed()
          }
          this.record = _.cloneDeep(this.defaultRecord)
          this.showCustomerSelect = false
          this.showShodanSelect = false
          const [day, month, year] = new Date().toLocaleDateString('en-GB').split('/')
          this.record.quotationDate = `${year}-${month}-${day}` // only to support this.formatDate() in computed property
        }, 300)
      },
      async finishCreation () {
        let isErr = false
        if (!_.isEmpty(this.record.id)) { // Update quotation
          this.record.itemDetails = this.dataList
          let tableItem = this.record
          tableItem.customer = this.record.customerSelect
          let endpoint = `api/quo`
          let method = 'patch'
          try {
            let response = await this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
            console.debug('success save quotation')
            this.saveQuoInline('Quotation Updated')
          } catch (error) {
            console.log(error)
            this.cancelInline()
            isErr = true
          }
        } else { // create new quotation
          this.record.itemDetails = this.dataList
          let tableItem = this.record
          // this.DataList.push(this.editedItem)
          tableItem.customer = this.record.customerSelect
          let endpoint = `api/quo`
          let method = 'post'
          try {
            let response = await this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
            console.debug('success save quotation')
            this.saveQuoInline('Quotation Created')
          } catch (error) {
            console.log(error)
            this.cancelInline()
            isErr = true
          }
        }
        if (!isErr) {
          this.showStepper = false
          this.e1 = 0
          this.clearForm()
          setTimeout(() => {
            this.$emit('eventQuoCreation', 2) // change tab in parent
          }, 1000)
          // END
        }
      },
      cancelCreation () {
        this.clearForm()
        this.showStepper = false
        this.e1 = 0
      },
      initQuot () {
        this.clearForm()
        this.editMode = false
        this.e1 = 1
        this.showStepper = true
        this.dataList = []
        this.$refs.form.validate()
      },
      async editQuotHeader () {
        this.editMode = true
        console.log(this.$store.state.quo.editQuoRecord)
        this.record = Object.assign({}, this.$store.state.quo.editQuoRecord)
        this.getCustomers()
        this.record.customerSelect = this.record.customer // for getShodans
        this.getShodans()
        this.searchCompany = this.record.customer.company.name
        this.getCompaniesPaging()
        this.e1 = 1
        this.showStepper = true
        this.dataList = this.record.itemDetails
        if (_.isEmpty(this.record.discType) ) {   // handle old data
          this.record.discType = 'PERCENTAGE'
        }
        this.$store.commit('quo/setSelectedItems', this.record.itemDetails) // allow directly gotoStep3 + remove warning
      },
      setCheckboxItemSelection () {
        // this.record.itemDetails
        if (!_.isEmpty(this.dataList)) {
          console.log('isBundling=' + this.record.isItemBundling)
          if (this.record.isItemBundling) { // Sync with the SELECT CHECKBOX
            this.$refs.itemBundlingSelectComponent.setSelectedItemsCheckbox(this.dataList)
          } else {
            this.$refs.itemSelectComponent.setSelectedItemsCheckbox(this.dataList)
          }
        }
      },
      /** v-stepper function **/
      checkStep1Complete () {
        return this.step1Complete
      },
      checkStep2Complete () {
        return this.step2Complete
      },
      async goStep1 () {
        this.fromStep4 = false
      },
      async goStep2 () {
        if (!this.step1Complete) {
          return false
        }
        this.e1 = 2
        this.fromStep4 = false
        // this.dataList = this.record.itemDetails // impact of editable step, moved to step1/edit/init
        // console.table(this.record.itemDetails)
        this.setCheckboxItemSelection()
      },
      async goStep3 () {
        if (this.fromStep4) {
          return true
        }
        if (!this.step2Complete || !this.step1Complete) {
          console.debug('step 3 invalid')
          return false
        }

        let temp = _.cloneDeep(this.$store.getters['quo/selectedItems'])
        let rates = await this.$http.get(`/api/exchangerate/select?tgt=IDR`)
        console.debug(temp)
        let isBundling = this.record.isItemBundling
        this.dataList = _.map(temp, function (object) {
          console.debug(object.currency)
          let value = _.find(rates.data, function (rate) {
            return rate.sourceCurr === object.currency && rate.targetCurr === 'IDR'
          })
          let cv = value ? value.convValue : 1
          console.debug(cv)
          object.currency = 'IDR'
          object.qtyType = isBundling ? 'SET' : 'PCS'
          object.price.sellingPrice = object.price.sellingPrice * cv
          object.price.bottomPrice = object.price.bottomPrice * cv
          return object
        })
        this.e1 = 3
      },
      async goStep4 () {
        if (!this.step2Complete || !this.step1Complete) {
          console.log('step 4 invalid')
          return false
        }
        if (_.isEmpty(this.dataList)) {
          await this.goStep3()
        }
        this.e1 = 4
        this.fromStep4 = true
        console.log(this.e1)
        this.setTotalPriceAttribute()
      },
      /** * end v-stepper function ***/
      async getUserLogins () {
        try {
          let response = await this.$http.get(`/api/userlogin/select?restrict=true`)
          this.userLogins = response.data
        } catch (error) {
          console.log(error)
        }
      },
      async getCustomers () {
        try {
          let response = await this.$http.get(`/api/customer/select?companyId=${this.record.customer.company.id}`)
          this.customers = response.data
          let custobj = _.find(this.customers, ['id', this.record.customer.id])
          this.record.customerSelect = custobj || ''
          this.showCustomerSelect = true
        } catch (error) {
          console.log(error)
        }
      },
      async getCompaniesPaging () { // paging not yet implemented
        try {
          // const { sortBy, descending, page, rowsPerPage } = this.pagination
          let q = this.searchCompany == null ? '' : this.searchCompany
          // let pageNoXHR = page - 1
          // let response = await this.$http.get(`/api/company/select?ps=${rowsPerPage}&pn=${pageNoXHR}&so=${sortBy}&dc=${descending}&q=${q}`)
          let response = await this.$http.get(`api/company/autocomplete?ps=100&pn=0&so=name&q=${q}`)

          this.companies = response.data
        } catch (error) {
          console.log(error)
        }
      },
      async getCompanies () {
        try {
          let response = await this.$http.get('/api/company/select')
          this.companies = response.data
        } catch (error) {
          console.log(error)
        }
      },
      async getShodans () {
        try {
          let response = await this.$http.get(`/api/shodan/select?status=OPEN&cid=${this.record.customerSelect.id || ''}`)
          this.shodans = response.data
          this.shodans.unshift({ id: null, name: '' })
          this.showShodanSelect = true
        } catch (error) {
          console.log(error)
        }
      },
      async getPaymentTerms () {
        try {
          let response = await this.$http.get('/api/quo/paymentTerm/select')
          this.paymentTerms = response.data
        } catch (error) {
          console.log(error)
        }
      },
      saveQuoInline (text) {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = text
      },
      saveInline () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data updated'
      },
      cancelInline () {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = 'Canceled'
      },
      closeInline () {
        console.debug('Dialog closed')
      }
    }
  }
</script>

<style>
  #quocreation-expand-step4 thead tr {
    background-color: antiquewhite !important;
  }

  #quocreation-expand-step3 thead tr {
    background-color: antiquewhite !important;
  }
</style>
